/**
 * NestJS-API-Client (Phase N7 — Frontend-Cutover).
 *
 * Wraps `$fetch` mit:
 * - apiBase aus runtimeConfig.public.apiBase
 * - credentials: 'include' (HttpOnly-Cookie cross-origin)
 * - automatischer Bearer-Header wenn Auth-Store ein Token hat (Fallback)
 *
 * Verwendung in Components/Stores:
 *   const api = useApi()
 *   const data = await api<MyType>('/api/affiliate/programs?platform=awin')
 */
import { useAuthStore } from '~/stores/auth';

export const useApi = () => {
  const config = useRuntimeConfig();
  const authStore = useAuthStore();

  return <T = unknown>(path: string, opts: Parameters<typeof $fetch>[1] = {}) => {
    const url = path.startsWith('http') ? path : `${config.public.apiBase}${path}`;
    const headers: Record<string, string> = {
      ...(opts?.headers as Record<string, string> | undefined),
    };
    // Bearer-Fallback wenn Cookie cross-origin nicht durchkommt (z.B. local dev)
    if (authStore.token && !headers.Authorization) {
      headers.Authorization = `Bearer ${authStore.token}`;
    }
    return $fetch<T>(url, {
      credentials: 'include',
      ...opts,
      headers,
    });
  };
};
